<div class="row text-center">
  <div class="col">    
      <ng-container *ngIf="isAcmic; else maHeader">
        <div class="header-icon full-icon">
          <svg-policy-svg></svg-policy-svg>
        </div>
        <h1 class="title-copy">{{ "ADD_POLICY_TITLE" | translate }}</h1>
      </ng-container>
      <ng-template #maHeader>
        <div class="header-icon full-icon">
          <img src="./assets/img/images/icon-ma-insurance.svg" alt="MA insurance icon"/>  
        </div>
        <h1 class="title-copy font-weight-normal margin-bottom mb24">{{ "ADD_POLICY_TITLE" | translate }}</h1>      
      </ng-template>          
  </div>
</div>
<app-add-policy-form [inputs]="addPolicy"></app-add-policy-form>
<div class="row text-center margin-top mt16">
  <div class="col">
    <mapfre-modal [modalOptions]="whereToFindModalOptions">
      <div class="modal-body no-padding-top">
        <hr class="margin-bottom mb24" />
        <div class="margin-bottom mb8 fs-14">
          {{ "SEARCH_YOUR_POLICY_DOCUMENTS_INVOICES" | translate }}
        </div>
        <div class="margin-bottom mb24">
          <img src="./assets/img/images/Document_ref.png" alt="document icon" />
        </div>
      </div>
    </mapfre-modal>
  </div>
</div>
<div class="row text-center">
  <div class="col">
    <mapfre-button
      additionalClasses="link-button red-link small w-100 button-border-red margin-top mt24 h24"
      [backIcon]="'assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      (click)="navigateBack()"
      [showIconsCustom]="true"
    >
      {{ "BACK" | translate }}
    </mapfre-button>
  </div>
</div>
